import Point from '../../../Utility/Point';
import Sprite from '../../Sprite';

export default class TNT extends Sprite {
    public create(params: any): void {
        super.create({
            name: 'tntSprite',
            texture: 'canister_booster_ingame',
            anchor: new Point(0.5, 0.5),
        });
    }
}
